import React, { useEffect, useState } from "react";
import { Avatar, Button, Spinner } from "@heroui/react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { useSession } from "@clerk/clerk-react";
import { API_URL } from "constants/index";
import { useChat } from "shared/contexts/chat.context";
import ella from "assets/ella.png";

const ChatPopup = () => {
  const { session } = useSession();
  const { isOpen, prompt, closeChat } = useChat();
  const [isLoading, setIsLoading] = useState(false);
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    if (prompt) {
      resetChat();
      handleSendMessage(prompt);
    }
  }, [prompt]);

  const resetChat = () => {
    setAnswer("");
    setIsLoading(false);
  };

  const handleSendMessage = async (message: string) => {
    console.log("Sending a question to AI chat:", message);
    setIsLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/kaylee/ask-simple-system`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message }),
        },
        session
      );
      const data = await response.text();
      setAnswer(data);
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  const formattedAnswer = answer.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <div className="fixed bottom-8 right-8 w-[25vw] h-[30vh] bg-brick-secondary-fine bg-opacity-90 shadow-2xl rounded-3xl p-4 flex flex-col z-10000">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Avatar src={ella} size="md" />
          <span className="font-semibold text-lg">Ella suggesties</span>
        </div>
        <Button className="bg-secondary" onClick={closeChat}>
          ×
        </Button>
      </div>
      <div className="chat-messages flex flex-col gap-2 mt-4 overflow-y-auto">
        <div>{formattedAnswer}</div>
        {isLoading && <Spinner size="sm" color="primary" />}
      </div>
    </div>
  );
};

export default ChatPopup;
